var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "14px",
    height: "16.001px",
    viewBox: "79.042 183.058 14 16.001",
    enableBackground: "new 79.042 183.058 14 16.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#1aba66",
    clipRule: "evenodd",
    d: "M81.085,196.482c0.953-0.181,1.906-0.367,2.859-0.552 c0.379-0.073,0.723-0.22,0.998-0.485c2.434-2.338,4.877-4.667,7.292-7.022c1.077-1.051,1.066-2.765,0.036-3.858 c-0.195-0.208-0.399-0.409-0.601-0.613c-0.589-0.602-1.321-0.88-2.17-0.893c-0.817,0.014-1.524,0.275-2.104,0.834 c-2.392,2.305-4.781,4.611-7.174,6.916c-0.276,0.266-0.458,0.58-0.538,0.943c-0.208,0.934-0.415,1.869-0.605,2.807 C78.838,195.744,79.856,196.717,81.085,196.482z M80.734,194.711c0.177-0.846,0.347-1.693,0.518-2.54 c0.025-0.129,0.096-0.226,0.19-0.316c2.349-2.261,4.694-4.522,7.04-6.786c0.274-0.264,0.599-0.403,0.989-0.393 c0.34-0.006,0.638,0.102,0.883,0.329c0.232,0.217,0.469,0.433,0.687,0.664c0.521,0.553,0.524,1.235-0.019,1.763 c-2.368,2.301-4.745,4.592-7.117,6.889c-0.097,0.094-0.205,0.146-0.338,0.166c-0.874,0.139-1.749,0.274-2.622,0.423 C80.746,194.943,80.693,194.903,80.734,194.711z M92.02,197.518c-4.026-0.003-8.053-0.001-12.079-0.001 c-0.064,0-0.13,0.004-0.194,0.013c-0.451,0.061-0.708,0.366-0.679,0.802c0.029,0.441,0.366,0.723,0.885,0.724 c2.003,0.002,4.005,0.001,6.008,0.001h4.318c0.605,0,1.213,0.01,1.818-0.005c0.571-0.014,0.938-0.437,0.826-0.924 C92.837,197.752,92.504,197.518,92.02,197.518z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit01);
export default __webpack_public_path__ + "static/media/edit-01.1b2deef9c043cd1ee235592185f57bdc.svg";
export { ForwardRef as ReactComponent };